import css from "./Footer.module.css"


function Footer() {
    return (
        <div className={`${css.Footer} d-flex flex-row justify-content-between text-center align-items-center gap-4 w-100 text-white px-5`}>
            <img className={`${css.logop}`} src="/logop.jpg" alt=""/>
            <div className={`h-100 d-flex justify-content-center align-items-center p-0 m-0`}>
                <p className={"p-0 m-0"}>Rua Nicomedes Alves dos Santos Número 3600, Sala 203 Gávea Business
                    CEP 38411136</p>
            </div>
            <div className={"px-5 h-100 d-flex flex-column justify-content-center align-items-center"}>
                <p className={css.txtfooter}>(34) 99915-2255</p>
                <a className={` ${css.ig}`} href=""><img className={`${css.imgig}`} src="/instagram.webp" alt=""/>Instagram</a>
            </div>
        </div>
    );
}

export default Footer;
